/**
 * BudgetStatusService
 * Service for BudgetStatus lookup CRUD operations
 */
import { CrudService } from '../base/CrudService';
/** Service for BudgetStatus CRUD operations */
export class BudgetStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? BudgetStatusService.DEFAULT_SERVICE_PATH,
            basePath: BudgetStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
BudgetStatusService.DEFAULT_SERVICE_PATH = 'budgets';
BudgetStatusService.BASE_PATH = 'api/budgetstatuses';
//# sourceMappingURL=BudgetStatusService.js.map